import logo from './logo.svg';
import './App.css';
import { ConfigService } from './services/config';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <span>Environment: </span><strong>{ ConfigService.get('environmentName') }</strong>
          <br></br>
          <span>Sample API Hostname: </span><strong>{ ConfigService.get('hosts.api') }</strong>
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
